module.exports = __webpack_public_path__ + "edbe81a60438d58e0cc7291e9694047b.jpg";